import {
  fetchActivitiesDeepLink,
  fetchWlBookingComHotelsDeepLink,
  fetchBookingComDeepLink,
  fetchBookingComCarsDeepLink,
  fetchExpediaDeepLink,
  fetchImpalaDeepLink,
  fetchRentalCarsDeepLink,
  fetchKayakCarsDeepLink,
  fetchKayakStaysDeepLink,
  fetchClickthroughDeepLink,
  fetchVioDeepLink,
} from '../services/deepLinks/deepLinksEndpoints';
import { logInfo } from '../shared/logger';
import type { Redirect } from '../shared/types/Redirect';
import type { DeepLinkResult } from '../shared/types/FetchDeepLink';

const fetchDeepLink = async (redirect: Redirect): Promise<DeepLinkResult> => {
  logInfo(`Fetching deep link for campaign: ${redirect.campaign}`);

  switch (redirect.campaign) {
    case 'getyourguide':
      return fetchActivitiesDeepLink(redirect);
    case 'rentalcars':
      return fetchRentalCarsDeepLink(redirect);
    case 'wl-bookingcom-hotels':
      return fetchWlBookingComHotelsDeepLink(redirect);
    case 'bookingcom-cars':
      return fetchBookingComCarsDeepLink(redirect);
    case 'impala':
      return fetchImpalaDeepLink(redirect);
    case 'expedia':
      return fetchExpediaDeepLink(redirect);
    case 'kayak-cars':
      return fetchKayakCarsDeepLink(redirect);
    case 'kayak-stays':
      return fetchKayakStaysDeepLink(redirect);
    case 'vio':
      return fetchVioDeepLink(redirect);
    case 'clickthrough':
      return fetchClickthroughDeepLink(redirect);
    // every disabled partner will fallback to bookingCom
    default:
      return fetchBookingComDeepLink(redirect);
  }
};

export default fetchDeepLink;
